export const COURSE_DETAIL_TABS = [
  { id: "description", label: "상세설명" },
  { id: "curriculum", label: "교육과정" },
  { id: "qna", label: "QnA" },
];

export const COURSE_CERTIFICATE_NOTE = "전체 강의 수강 완료 후 제공";

const OPEN_EVENT_REMOVAL_PATTERNS = [
  /오픈\s*기념\s*이벤트!?\s*/gi,
  /오픈\s*기념으로\s*(?:한\s*달|한달)\s*동안은?\s*테스트\s*없이\s*수료증을?\s*바로\s*출력\s*가능하십니다\.?\s*/gi,
  /\*?\s*이벤트\s*:\s*테스트\s*없이\s*바로\s*출력\s*가능\s*\*?/gi,
  /제공\s*\(\s*\*\s*이벤트\s*:[^)]*\)\s*/gi,
];

export function sanitizeCourseDescription(description) {
  if (typeof description !== "string" || !description.trim()) {
    return description;
  }

  let text = description;
  for (const pattern of OPEN_EVENT_REMOVAL_PATTERNS) {
    text = text.replace(pattern, "");
  }

  return text.replace(/\n{3,}/g, "\n\n").trim();
}

export const COURSE_ENROLLMENT_PERIOD = "무제한";

export function formatCoursePriceParts(value) {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return { amount: "", unit: "원" };
  }
  return { amount: value.toLocaleString(), unit: "원" };
}

export function getCourseMetaRows(course) {
  const sectionCount = course?.sections?.length ?? 0;
  const lectureCount =
    course?.total_lecture_count ??
    course?.sections?.reduce(
      (sum, section) => sum + (section.lectures?.length ?? 0),
      0
    ) ??
    0;

  return [
    {
      label: "교육과정",
      value: sectionCount > 0 ? `${sectionCount}개` : `${lectureCount}개`,
    },
    {
      label: "교육시간",
      value: course?.duration || course?.total_duration || "-",
    },
    { label: "수강기한", value: COURSE_ENROLLMENT_PERIOD },
    { label: "수료증", value: COURSE_CERTIFICATE_NOTE },
  ];
}

// "HH:MM:SS" 또는 "MM:SS" 문자열을 총 초로 변환한다. 파싱 불가 시 0.
export function parseHmsSeconds(hms) {
  if (typeof hms !== "string") return 0;
  const parts = hms.split(":").map((n) => parseInt(n, 10));
  if (parts.length < 2 || parts.some(Number.isNaN)) return 0;
  const [h, m, s] = parts.length === 3 ? parts : [0, parts[0], parts[1]];
  return h * 3600 + m * 60 + s;
}

// "HH:MM:SS" → ISO 8601 duration(PT14M47S). 0이면 undefined.
export function toIso8601Duration(hms) {
  const total = parseHmsSeconds(hms);
  if (!total) return undefined;
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return `PT${h ? `${h}H` : ""}${m ? `${m}M` : ""}${s ? `${s}S` : ""}`;
}

// "HH:MM:SS" → 사람이 읽는 시간("14분 47초"). 0이면 빈 문자열.
export function humanizeDuration(hms) {
  const total = parseHmsSeconds(hms);
  if (!total) return "";
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const parts = [];
  if (h) parts.push(`${h}시간`);
  if (m) parts.push(`${m}분`);
  if (s) parts.push(`${s}초`);
  return parts.join(" ");
}

// 교육과정의 전체 강의 개수를 구한다.
export function getCourseLectureCount(course) {
  return (
    course?.total_lecture_count ??
    course?.sections?.reduce(
      (sum, section) => sum + (section.lectures?.length ?? 0),
      0
    ) ??
    0
  );
}

export function maskUserName(name) {
  if (!name || name.length < 2) return name || "";
  return `${name[0]}*${name.slice(-1)}`;
}

export function formatQnaDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}.${m}.${d}`;
}

export function getCommentCount(inquiry) {
  if (Array.isArray(inquiry?.comments)) return inquiry.comments.length;
  if (typeof inquiry?.comment_count === "number") return inquiry.comment_count;
  return 0;
}

export function isEnrollmentLectureCompleted(enrollmentProgress, lectureId) {
  if (lectureId == null || !enrollmentProgress?.length) return false;
  const id = Number(lectureId);
  return enrollmentProgress.some(
    (item) => Number(item.lecture_id) === id && Boolean(item.is_completed)
  );
}
